import React from 'react'
import axios from 'axios'
import { useRouteMatch } from 'react-router-dom'
import styled from 'styled-components'
import { Input, Button, FormNav } from 'components'
import { isValidEmail } from '../../lib/validation';

const Wrapper = styled.div`
	@media (max-width: 480px) {
		display: flex;
		flex-wrap: wrap;
	}
`

const Field = styled.div`
	min-width: 0;
	flex: 1 1 100%;
	grid-column: ${props => (props.wide ? '1 / span 2' : '')};
`

const FieldSection = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: 16px;
	@media (max-width: 480px) {
		display: flex;
		flex-wrap: wrap;
	}
	padding: 18px 20px 6px;
	background: ${props => props.theme.softColor};
	border: 1px solid ${props => props.theme.lineColor};
	border-radius: ${props => props.theme.radius};
	margin-bottom: 14px;
`

const Label = styled.div`
	color: ${props => props.theme.primaryColor};
	grid-column: 1/-1;
	margin-bottom: 12px;
	font-size: 17px;
	font-weight: 700;
	display: flex;
	align-items: center;
	justify-content: space-between;
`

const OwnerInfo = ({
	onNext,
	page,
	totalPages,
	onPrev,
	loading,
	application,
	setApplication,
}) => {
	const [fields, setFields] = React.useState([{ name: '', email: '' }])
	const match = useRouteMatch('/form/:applicationId')

	const updateField = (i, field, value) => {
		setFields(status => {
			status[i][field] = value
			return [...status]
		})
	}

	const updateOwners = () => {
		axios
			.put('/api/applications/' + match.params.applicationId, {
				stakeHolders: fields
					.filter(f => f.name !== '' && f.email !== '')
					.map(f => ({
						...f,
						companyId: application.id,
					})),
			})
			.then(res => setApplication(res.data))
			.then(onNext)
	}

	const isEmptyOwner = owner => !owner.name?.trim() && !owner.email?.trim()

	const isValidOwners = () => {
		const filled = fields.filter(owner => !isEmptyOwner(owner))
		if (filled.length < 1) {
			return false
		}
		return filled.every(
			owner => isValidEmail(owner.email) && !!owner.name?.trim(),
		)
	}

	const disableAdd = fields.length >= 100

	const addOwner = () => {
		if (!disableAdd) {
			setFields(f => [...f, { name: '', email: '' }])
		}
	}

	const removeOwner = index => {
		setFields(f => {
			if (f.length <= 1) {
				return f
			}
			return f.filter((_, i) => i !== index)
		})
	}

	React.useEffect(() => {
		if (application.stakeHolders?.length > 0) {
			setFields(application.stakeHolders)
		}
	}, [application.stakeHolders])

	return (
		<Wrapper>
			{fields.map((field, i) => {
				return (
					<FieldSection key={field.id || i}>
						<Label>
							<span>Omistaja {i + 1}</span>
							{fields.length > 1 && (
								<Button variant="small" onClick={() => removeOwner(i)}>
									Poista
								</Button>
							)}
						</Label>
						<Field>
							<Input
								name="name"
								value={fields[i].name}
								onChange={e => updateField(i, 'name', e.target.value)}
								type="text"
								label={'Koko nimi'}
							/>
						</Field>
						<Field>
							<Input
								value={fields[i].email}
								type="email"
								label={'Sähköposti'}
								onChange={e => updateField(i, 'email', e.target.value)}
							/>
						</Field>
					</FieldSection>
				)
			})}
			<Field wide style={{ marginTop: 4 }}>
				<Button variant="outline" onClick={addOwner} disabled={disableAdd}>
					+ Lisää osakkeenomistaja
				</Button>
			</Field>
			<FormNav
				page={page}
				totalPages={totalPages}
				onNext={updateOwners}
				onPrev={onPrev}
				loading={loading}
				disabled={!isValidOwners()}
			/>
		</Wrapper>
	)
}

export default OwnerInfo
